var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTheta(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.44 1h15.12L25 2.49v27.02L23.56 31H8.44L7 29.51V2.49L8.44 1zm1.44 27.02h12.24V3.98H9.88v24.04zm10.7-7.756h-3.13v3.395h-2.826v-3.394h-3.13v-2.924h9.087v2.923zm0-8.372v2.922h-9.086v-2.922h3.13V8.497h2.827v3.395h3.13z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTheta);
export default __webpack_public_path__ + "static/media/THETA.79c1084c30ea4816fec67eaf56f7021d.svg";
export { ForwardRef as ReactComponent };